import React from 'react';

interface IMagnifyingGlass {
  className?: string;
}

export default function MagnifyingGlass({ className }: IMagnifyingGlass) {
  return (
    <svg className={className} xmlns="http://www.w3.org/2000/svg">
      <path d="M15.6344 13.8656L11.8938 10.125C12.7444 8.86219 13.1641 7.28438 12.9394 5.60313C12.5563 2.74344 10.2125 0.416254 7.35002 0.0538482C3.09408 -0.484683 -0.484669 3.09407 0.0538932 7.35C0.416393 10.2138 2.74389 12.5594 5.60389 12.9406C7.28514 13.1653 8.86327 12.7458 10.1258 11.895L13.8664 15.6356C14.3545 16.1238 15.1461 16.1238 15.6342 15.6356C16.1219 15.1469 16.1219 14.3531 15.6344 13.8656ZM2.47189 6.5C2.47189 4.29438 4.26627 2.5 6.47189 2.5C8.67752 2.5 10.4719 4.29438 10.4719 6.5C10.4719 8.70563 8.67752 10.5 6.47189 10.5C4.26627 10.5 2.47189 8.70625 2.47189 6.5Z" />
    </svg>
  );
}
